module.exports = __webpack_public_path__ + "static/media/account_circle.29761e0a.svg";